export default "__VITE_ASSET__BTNKREza__"